export const hasCity = function(places, deliveryOption) {
  var city = false;

  if (places.items) {
    places.items.forEach((area, index) => {
      if (area.name === deliveryOption.delivery_district.value) {
        city = area.hasOwnProperty("subitems");
      }
    });
  }
  return city;
};
